import ProductService from '@/services/ProductService.js'

export const state = {
  productCategories: [],
  productCategory: {}
}

export const mutations = {
  ADD_PRODUCT_CATEGORY(state, productCategory) {
    state.productCategories.push(productCategory)
  },
  DELETE_PRODUCT_CATEGORY(state, productCategory) {
    state.productCategories = state.productCategories.filter(
      t => t.id != productCategory.id
    )
  },
  SET_PRODUCT_CATEGORIES(state, productCategories) {
    state.productCategories = productCategories
  },
  SET_PRODUCT_CATEGORY(state, productCategory) {
    state.productCategory = productCategory
  },
  EDIT_PRODUCT_CATEGORY(state, productCategory) {
    state.productCategory = productCategory
  }
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  createProductCategory({ commit, dispatch }, productCategory) {
    return ProductService.postProductCategory(productCategory)
      .then(response => {
        if (response.data.error && response.data.error === true) {
          const notification = {
            type: 'error',
            message: response.data.message
          }
          dispatch('notification/add', notification, { root: true })
          throw response.data
        } else {
          commit('ADD_PRODUCT_CATEGORY', productCategory)
          const notification = {
            type: 'success',
            message: 'Your new product category has been created!'
          }
          dispatch('notification/add', notification, { root: true })
          return response.data
        }
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message:
            'There was a problem creating new product category: ' +
            error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchProductCategories({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      ProductService.getProductCategories()
        .then(response => {
          commit('SET_PRODUCT_CATEGORIES', response.data)
          return resolve(response.data)
        })
        .catch(error => {
          const notification = {
            type: 'error',
            message:
              'There was a problem fetching product categories: ' + error.message
          }
          dispatch('notification/add', notification, { root: true })
          return reject(error)
        })
    })
  },
  fetchProductCategory({ commit, getters }, id) {
    var productCategory = getters.getProductCategoryById(id)

    if (productCategory) {
      commit('SET_PRODUCT_CATEGORY', productCategory)
      return productCategory
    } else {
      return ProductService.getProductCategory(id) // <-- Send the prop id to our ProductService//
        .then(response => {
          commit('SET_PRODUCT_CATEGORY', response.data)
          return response.data[0]
        })
    }
  },
  async removeProductCategory({ commit }, productCategory) {
    return ProductService.deleteProductCategory(productCategory)
    .then((response) => {
      if (response.data.success === true) {
        commit('DELETE_PRODUCT_CATEGORY', productCategory)
      } else {
        alert(response.data.message)
      }
    })
    .catch(error => {
      throw error
    })

  },
  editProductCategory({ commit }, productCategory) {
    ProductService.updateProductCategory(productCategory)
    commit('EDIT_PRODUCT_CATEGORY', productCategory)
  }
}

export const getters = {
  getProductCategoryById: state => id => {
    return state.productCategories.find(
      productCategory => productCategory.id === id
    )
  }
}
